import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-delete-dialog',
  templateUrl: './delete-dialog.component.html',
  styleUrls: ['./delete-dialog.component.scss']
})
export class DeleteDialogComponent {
  public title: string;
  public message: string;

  constructor(
    protected dialogRef: MatDialogRef<DeleteDialogComponent>,
    @Inject(MAT_DIALOG_DATA) protected data: string | { title: string, message: string }
  ) {
    if (typeof data === 'string')
      this.title = data;
    else {
      this.title = data.title;
      this.message = data.message;
    }
  }

  cancel() {
    this.dialogRef.close(false);
  }

  acceptDelete() {
    this.dialogRef.close(true);
  }
}
